export default __webpack_public_path__ + "static/media/Previous.53411356.svg";